import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Funciona si soy muy introvertido o me quedo "en blanco"?',
    a: 'Justo para eso fue diseñado. Este no es un libro de "consejos genéricos", es un protocolo mecánico. Te da la estructura exacta de qué hacer y qué decir para que nunca tengas que depender de la inspiración o de la suerte.'
  }, {
    q: '¿Esto es para "ligar" o seducción barata?',
    a: 'No. Esto es Psicología Social Aplicada. Se trata de desarrollar un magnetismo real que haga que las mujeres (y las personas en general) se sientan atraídas por tu presencia de forma natural, sin usar frases ensayadas o comportamientos raros.'
  }, {
    q: '¿En cuánto tiempo veré resultados?',
    a: 'Los cambios en tu lenguaje corporal y proyección de voz son instantáneos. Una vez que aplicas los primeros 3 activadores, notarás que la gente te presta más atención y te interrumpe menos desde la primera conversación.'
  }, {
    q: '¿Qué pasa si ya he intentado otros cursos antes?',
    a: 'La mayoría de los cursos te dicen "ten confianza". Nosotros te decimos CÓMO proyectar esa confianza mediante activadores biológicos que el cerebro humano no puede ignorar. Es la diferencia entre teoría y un sistema probado.'
  }, {
    q: '¿Es seguro el pago y cómo recibo el material?',
    a: 'El pago es procesado por Hotmart, la plataforma de productos digitales más segura del mundo. Una vez realizado el pago de $132 MXN, recibirás un correo instantáneo con tu acceso al manual y todos los bonos para leerlos en cualquier dispositivo.'
  }];
  return <section className="py-12 bg-surface-section" data-id="element-70">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="text-center mb-10" data-id="element-72">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-73">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-74">
          {faqs.map((faq, index) => <div key={index} className={`border border-surface-border rounded-xl bg-surface-card overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-gold/50' : ''}`} data-id="element-75">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-76">
                <span className="font-heading font-bold text-base md:text-lg text-white pr-4" data-id="element-77">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-78" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-60 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-79">
                <p className="font-body text-gray-400 leading-relaxed text-base" data-id="element-80">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}